const SourceTypeFilter = ({ sourceTypeConfig, selectedType, onSelectType, action }) => {
  return (
    <div className="flex gap-2 flex-wrap items-center">
      <button
        className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          selectedType === 'all'
            ? 'bg-primary text-white'
            : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
        }`}
        onClick={() => onSelectType('all')}
      >
        All Sources
      </button>
      {Object.entries(sourceTypeConfig).map(([type, config]) => {
        const Icon = config.icon;
        return (
          <button
            key={type}
            className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              selectedType === type
                ? 'bg-primary text-white'
                : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
            onClick={() => onSelectType(type)}
          >
            <Icon className="h-4 w-4" />
            {config.label}
          </button>
        );
      })}
      {action}
    </div>
  );
};

export default SourceTypeFilter;
